export { default as calendarIconsRegistration } from './data/miniCalendarIconsRegistration';
export { default as CalendarIcons } from './data/MiniCalendarIcons';
